import {mapGetters} from 'vuex';
import Intersection from '~/components/core/Intersection';

export default {
  components: {Intersection},
  async created() {
    await this.getPublications();
  },
  data: () => ({
    noResults: false,
    loading: false,
    filters: {},
    prevFilters: {},
  }),
  methods: {
    async getPublications() {
      this.loading = true;
      if (Object.keys(this.filters).length === 0) {
        this.filters = this.$route.query;
      }

      try {
        const {data} = await this.$axios.get('/search', {
          params: {
            page: this.nextPage,
            cat: this.category,
            ...this.filters,
          },
        });

        await this.$store.dispatch('publications/setPublications', {
          category: this.category,
          publications: [...this.publications, ...data.data],
        });
        await this.$store.dispatch('publications/setNextPage', {
          category: this.category,
          nextPage: this.nextPage + 1,
        });
      } catch (e) {
        console.error(e);
        this.noResults = true;
      }
      this.loading = false;
    },
    async getNextPage() {
      if (this.publications.length > 0) {
        await this.getPublications();
      }
    },
    async selectedFilters(filters) {
      this.prevFilters = JSON.parse(JSON.stringify(this.filters));
      this.filters = JSON.parse(JSON.stringify(filters));

      await this.$store.dispatch('publications/setPublications', {
        category: this.category,
        publications: [],
      });
      await this.$store.dispatch('publications/setNextPage', {
        category: this.category,
        nextPage: 1,
      });

      this.$nextTick(async () => {
        await this.getPublications();
        await this.$router.push({path: this.$route.path, query: filters});
      });
    },
  },
  computed: {
    ...mapGetters({
      allPublications: 'publications/publications',
      nextPageGetter: 'publications/nextPage',
    }),
    publications() {
      return this.allPublications(this.category) || [];
    },
    nextPage() {
      return this.nextPageGetter(this.category);
    },
    category() {
      return this.$route.name === 'publicaties' ? null : this.$route.fullPath.replace(/^\//, '').split(/[?#]/)[0];
    },
  },
};
